import { RootState } from 'store/rootReducer';
import { getContractBasedDataSelector } from '@cp-shared-19/frontend-integration';

export const TotalEarlySettlementDataSelector = getContractBasedDataSelector(
    (state: RootState) => state.totalEarlySettlement,
);
